const baseKey = 'CryptoPorfolio:';

export const sessionKeys = {
    token: baseKey + 'token',
    user: baseKey + 'user'
}